import NiceModal, { useModal } from '@ebay/nice-modal-react'
import React from 'react'
import { createMVPModal } from '../Modal'
import SelectDeckModal from '../SelectDeckModal/SelectDeckModal'
import { SettingsModalView } from './SettingsModalView'

class SettingsModal
{
	Show() 
	{
		NiceModal.show(createMVPModal('settings-modal', () =>
		{
			const modal = useModal()

			const handleClick = (onClick: () => void) => {
				modal.hide()
				onClick()
			}

			const clickSelectDeck = () => {
				SelectDeckModal.Show()
			}

			return <SettingsModalView 
				clickSelectDeck={() => handleClick(clickSelectDeck)}
			/>
		}))
	}
}

const modal = new SettingsModal()
export default modal